import React, {useEffect, useState, useMemo, useRef } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'

import ReactQuill from 'react-quill-new';
import Swal from 'sweetalert2';

import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";

import { API_BASE } from "../config/api";

const initialCarruselForm = {
    carrusel_seccion: "superior",
    carrusel_titulo: "",
    carrusel_descripcion: "",
    carrusel_imagen: null,
    carrusel_url: "",
    carrusel_fecha_inicio: "",
    carrusel_fecha_fin: "",
    carrusel_orden: 1,
    carrusel_activo: 1,
};

const initialEditCarruselForm = {
    carrusel_id: "",
    carrusel_seccion: "superior",
    carrusel_titulo: "",
    carrusel_descripcion: "",
    carrusel_url: "",
    carrusel_fecha_inicio: "",
    carrusel_fecha_fin: "",
    carrusel_orden: 1,
    carrusel_activo: 1,
    carrusel_imagen: null,
    carrusel_imagen_actual: "",
};

const monthOptions = [
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
];

function CarruselList() {

    const [carruselList, setCarruselList] = useState([]);
    const [loadingCarrusel, setLoadingCarrusel] = useState(false);
    const [carruselListError, setCarruselListError] = useState("");

    const [carruselForm, setCarruselForm] = useState(initialCarruselForm);
    const [addingCarrusel, setAddingCarrusel] = useState(false);

    const [carruselSuccessMessage, setCarruselSuccessMessage] = useState("");
    const [carruselInfoMessage, setCarruselInfoMessage] = useState("");
    const [carruselErrorMessage, setCarruselErrorMessage] = useState("");

    const [carruselImagePreview, setCarruselImagePreview] = useState("");

    const [viewCarruselData, setViewCarruselData] = useState(null);
    const [loadingViewCarrusel, setLoadingViewCarrusel] = useState(false);
    const [viewCarruselError, setViewCarruselError] = useState("");

    const [editCarruselForm, setEditCarruselForm] = useState(initialEditCarruselForm);
    const [loadingEditCarrusel, setLoadingEditCarrusel] = useState(false);
    const [savingEditCarrusel, setSavingEditCarrusel] = useState(false);

    const [editCarruselSuccessMessage, setEditCarruselSuccessMessage] = useState("");
    const [editCarruselInfoMessage, setEditCarruselInfoMessage] = useState("");
    const [editCarruselErrorMessage, setEditCarruselErrorMessage] = useState("");

    const [editCarruselImagePreview, setEditCarruselImagePreview] = useState("");

    const [searchTerm, setSearchTerm] = useState("");
    const [sectionFilter, setSectionFilter] = useState("");
    const [dateFilterMode, setDateFilterMode] = useState("basic"); // basic | advanced
    const [monthFilter, setMonthFilter] = useState("");
    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [downloadingReport, setDownloadingReport] = useState(false);

    const resetCarruselMessages = () => {
        setCarruselSuccessMessage("");
        setCarruselInfoMessage("");
        setCarruselErrorMessage("");
    };

    const resetCarruselForm = () => {
        setCarruselForm(initialCarruselForm);
        setCarruselImagePreview("");
    };

    const resetAddCarruselModal = () => {
        resetCarruselMessages();

        setCarruselForm({
            ...initialCarruselForm,
            carrusel_orden: getNextCarruselOrden(),
        });

        setCarruselImagePreview("");
        setAddingCarrusel(false);

        const fileInput = document.getElementById("carrusel_imagen");
        if (fileInput) fileInput.value = "";
    };

    // Helpers

    const getNextCarruselOrden = () => {
        if (!Array.isArray(carruselList) || carruselList.length === 0) {
            return 1;
        }

        const maxOrden = Math.max(
            ...carruselList.map((item) => Number(item.Carrusel_Orden || 0))
        );

        return maxOrden + 1;
    };

    const formatCarruselDateTime = (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleString("es-MX", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const formatCarruselDate = (value) => {
        if (!value) return "-";

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleDateString("es-MX", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };

    const getCarruselStatus = (item) => {
    const isActive = Number(item.Carrusel_Activo) === 1;

    if (!isActive) {
        return "inactive";
    }

    const now = new Date();

    const startDate = item.Carrusel_Fecha_Inicio
        ? new Date(item.Carrusel_Fecha_Inicio)
        : null;

    const endDate = item.Carrusel_Fecha_Fin
        ? new Date(item.Carrusel_Fecha_Fin)
        : null;

    if (startDate && !Number.isNaN(startDate.getTime()) && now < startDate) {
        return "scheduled";
    }

    if (endDate && !Number.isNaN(endDate.getTime()) && now > endDate) {
        return "finished";
    }

    return "active";
};

    const formatDateTimeLocal = (value) => {
    if (!value) return "";

    const cleanValue = String(value)
        .replace("T", " ")
        .replace("Z", "")
        .replace(/\.\d+$/, "")
        .trim();

    const [datePart, timePart = "00:00"] = cleanValue.split(" ");
    const [hours = "00", minutes = "00"] = timePart.split(":");

    return `${datePart}T${hours}:${minutes}`;
};

    const resetViewCarruselModal = () => {
        setViewCarruselData(null);
        setViewCarruselError("");
        setLoadingViewCarrusel(false);
    };

    const resetEditCarruselMessages = () => {
        setEditCarruselSuccessMessage("");
        setEditCarruselInfoMessage("");
        setEditCarruselErrorMessage("");
    };

    const resetEditCarruselForm = () => {
        setEditCarruselForm(initialEditCarruselForm);
        setEditCarruselImagePreview("");
    };

    const resetEditCarruselModal = () => {
        resetEditCarruselMessages();
        resetEditCarruselForm();
        setLoadingEditCarrusel(false);
        setSavingEditCarrusel(false);
    };

    // Funcion para Cargar Lista de Carrusel 
    const loadCarrusel = async () => {
        try {
            setLoadingCarrusel(true);
            setCarruselListError("");

            const response = await fetch(`${API_BASE}/api/admin/widgets/carrusel`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener el listado del carrusel");
            }

            setCarruselList(Array.isArray(data?.data) ? data.data : []);
        } catch (error) {
            console.error("Error al cargar carrusel:", error);
            setCarruselList([]);
            setCarruselListError(
                error.message || "Ocurrió un error al cargar los elementos del carrusel"
            );
        } finally {
            setLoadingCarrusel(false);
        }
    };

    useEffect(() => {
        loadCarrusel();
    }, []);

    const handleCarruselInputChange = (event) => {
        const { name, value } = event.target;

        let finalValue = value;

        if (name === "carrusel_activo" || name === "carrusel_orden") {
            finalValue = Number(value);
        }

        setCarruselForm((prev) => ({
            ...prev,
            [name]: finalValue,
        }));
    };

    const handleCarruselDescriptionChange = (value) => {
        setCarruselForm((prev) => ({
            ...prev,
            carrusel_descripcion: value || "",
        }));
    };

    const handleCarruselImageChange = (event) => {
        const file = event.target.files?.[0] || null;

        setCarruselForm((prev) => ({
            ...prev,
            carrusel_imagen: file,
        }));

        if (!file) {
            setCarruselImagePreview("");
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        setCarruselImagePreview(objectUrl);
    };

    const validateCarruselForm = () => {
        if (!carruselForm.carrusel_seccion) {
            return "La sección es requerida";
        }

        if (!carruselForm.carrusel_imagen) {
            return "La imagen es requerida";
        }

        if (
            Number.isNaN(Number(carruselForm.carrusel_orden)) ||
            Number(carruselForm.carrusel_orden) < 1
        ) {
            return "El orden debe ser un número mayor o igual a 1";
        }

        if (!carruselForm.carrusel_fecha_inicio) {
            return "La fecha de inicio es requerida";
        }

        if (!carruselForm.carrusel_fecha_fin) {
            return "La fecha de fin es requerida";
        }

        const fechaInicio = new Date(carruselForm.carrusel_fecha_inicio);
        const fechaFin = new Date(carruselForm.carrusel_fecha_fin);

        if (Number.isNaN(fechaInicio.getTime())) {
            return "La fecha de inicio no es válida";
        }

        if (Number.isNaN(fechaFin.getTime())) {
            return "La fecha de fin no es válida";
        }

        if (fechaFin.getTime() < fechaInicio.getTime()) {
            return "La fecha de fin no puede ser menor que la fecha de inicio";
        }

        return null;
    };

    const handleViewCarrusel = async (carruselId) => {
        try {
            setLoadingViewCarrusel(true);
            setViewCarruselError("");
            setViewCarruselData(null);

            const response = await fetch(
                `${API_BASE}/api/admin/widgets/carrusel/${carruselId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No fue posible obtener el detalle del carrusel"
                );
            }

            setViewCarruselData(data?.data || null);
        } catch (error) {
            console.error("Error al obtener detalle del carrusel:", error);
            setViewCarruselError(
                error.message || "Ocurrió un error al obtener el detalle del carrusel"
            );
        } finally {
            setLoadingViewCarrusel(false);
        }
    };

    const handleEditCarruselInputChange = (event) => {
        const { name, value } = event.target;

        let finalValue = value;

        if (name === "carrusel_orden" || name === "carrusel_activo") {
            finalValue = Number(value);
        }

        setEditCarruselForm((prev) => ({
            ...prev,
            [name]: finalValue,
        }));
    };

    const handleEditCarruselImageChange = (event) => {
        const file = event.target.files?.[0] || null;

        setEditCarruselForm((prev) => ({
            ...prev,
            carrusel_imagen: file,
        }));

        if (!file) {
            setEditCarruselImagePreview(editCarruselForm.carrusel_imagen_actual || "");
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        setEditCarruselImagePreview(objectUrl);
    };

    const validateEditCarruselForm = () => {
        if (!editCarruselForm.carrusel_seccion) {
            return "La sección es requerida";
        }

        if (
            Number.isNaN(Number(editCarruselForm.carrusel_orden)) ||
            Number(editCarruselForm.carrusel_orden) < 1
        ) {
            return "El orden debe ser un número mayor o igual a 1";
        }

        return null;
    };

    // Funcion para crear elemento del carrusel 

    const handleAddCarrusel = async (event) => {
        event.preventDefault();
        resetCarruselMessages();

        const validationError = validateCarruselForm();

        if (validationError) {
            setCarruselInfoMessage(validationError);
            return;
        }

        try {
            setAddingCarrusel(true);

            const formData = new FormData();
            formData.append("carrusel_imagen", carruselForm.carrusel_imagen);
            formData.append("carrusel_seccion", carruselForm.carrusel_seccion);
            formData.append("carrusel_titulo", carruselForm.carrusel_titulo.trim() || "");
            formData.append("carrusel_descripcion", carruselForm.carrusel_descripcion || "");
            formData.append("carrusel_orden", String(carruselForm.carrusel_orden));
            formData.append("carrusel_activo", String(carruselForm.carrusel_activo));

            if (carruselForm.carrusel_url.trim()) {
                formData.append("carrusel_url", carruselForm.carrusel_url.trim());
            }

            formData.append(
                "carrusel_fecha_inicio",
                String(carruselForm.carrusel_fecha_inicio || "").replace("T", " ")
            );

            formData.append(
                "carrusel_fecha_fin",
                String(carruselForm.carrusel_fecha_fin || "").replace("T", " ")
            );

            const response = await fetch(`${API_BASE}/api/admin/widgets/carrusel`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No fue posible agregar el elemento del carrusel"
                );
            }

            setCarruselSuccessMessage(
                data?.message || "Elemento del carrusel agregado correctamente"
            );

            await loadCarrusel();

            setTimeout(() => {
                const modalElement = document.getElementById("addCarruselModal");

                if (modalElement && window.bootstrap?.Modal) {
                    const modalInstance =
                        window.bootstrap.Modal.getInstance(modalElement) ||
                        new window.bootstrap.Modal(modalElement);

                    modalInstance.hide();
                }

                resetAddCarruselModal();
            }, 1200);
        } catch (error) {
            console.error("Error al agregar carrusel:", error);
            setCarruselErrorMessage(
                error.message || "Ocurrió un error al agregar el elemento del carrusel"
            );
        } finally {
            setAddingCarrusel(false);
        }
    };

    useEffect(() => {
        const modalElement = document.getElementById("addCarruselModal");

        if (!modalElement) return;

        const handleHiddenModal = () => {
            resetAddCarruselModal();
        };

        modalElement.addEventListener("hidden.bs.modal", handleHiddenModal);

        return () => {
            modalElement.removeEventListener("hidden.bs.modal", handleHiddenModal);
        };
    }, []);

    // Funcion para editar elemento del carrusel

    const handleLoadEditCarrusel = async (carruselId) => {
        try {
            setLoadingEditCarrusel(true);
            resetEditCarruselMessages();
            resetEditCarruselForm();

            const editFileInput = document.getElementById("edit_carrusel_imagen");
            if (editFileInput) editFileInput.value = "";

            const response = await fetch(
                `${API_BASE}/api/admin/widgets/carrusel/${carruselId}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No fue posible obtener el detalle del carrusel"
                );
            }

            const item = data?.data || null;

            setEditCarruselForm({
                carrusel_id: item?.Carrusel_ID || "",
                carrusel_seccion: item?.Carrusel_Seccion || "superior",
                carrusel_titulo: item?.Carrusel_Titulo || "",
                carrusel_descripcion: item?.Carrusel_Descripcion || "",
                carrusel_url: item?.Carrusel_URL || "",
                carrusel_fecha_inicio: formatDateTimeLocal(item?.Carrusel_Fecha_Inicio),
                carrusel_fecha_fin: formatDateTimeLocal(item?.Carrusel_Fecha_Fin),
                carrusel_orden: Number(item?.Carrusel_Orden ?? 1),
                carrusel_activo: Number(item?.Carrusel_Activo ?? 1),
                carrusel_imagen: null,
                carrusel_imagen_actual: item?.Carrusel_Imagen_URL || "",
            });

            setEditCarruselImagePreview(item?.Carrusel_Imagen_URL || "");
        } catch (error) {
            console.error("Error al cargar carrusel para editar:", error);
            setEditCarruselErrorMessage(
                error.message || "Ocurrió un error al cargar el elemento del carrusel"
            );
        } finally {
            setLoadingEditCarrusel(false);
        }
    };

    const handleUpdateCarrusel = async (event) => {
        event.preventDefault();
        resetEditCarruselMessages();

        const validationError = validateEditCarruselForm();

        if (validationError) {
            setEditCarruselInfoMessage(validationError);
            return;
        }

        try {
            setSavingEditCarrusel(true);

            const formData = new FormData();
            formData.append("carrusel_seccion", editCarruselForm.carrusel_seccion);
            formData.append("carrusel_titulo", editCarruselForm.carrusel_titulo.trim());
            formData.append(
                "carrusel_descripcion",
                editCarruselForm.carrusel_descripcion || ""
            );
            formData.append("carrusel_orden", String(editCarruselForm.carrusel_orden));
            formData.append("carrusel_activo", String(editCarruselForm.carrusel_activo));

            if (editCarruselForm.carrusel_url.trim()) {
                formData.append("carrusel_url", editCarruselForm.carrusel_url.trim());
            }

            formData.append(
                "carrusel_fecha_inicio",
                String(editCarruselForm.carrusel_fecha_inicio || "").replace("T", " ")
            );

            formData.append(
                "carrusel_fecha_fin",
                String(editCarruselForm.carrusel_fecha_fin || "").replace("T", " ")
            );

            if (editCarruselForm.carrusel_imagen) {
                formData.append("carrusel_imagen", editCarruselForm.carrusel_imagen);
            }

            const response = await fetch(
                `${API_BASE}/api/admin/widgets/carrusel/${editCarruselForm.carrusel_id}`,
                {
                    method: "PUT",
                    credentials: "include",
                    body: formData,
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No fue posible actualizar el elemento del carrusel"
                );
            }

            setEditCarruselSuccessMessage(
                data?.message || "Elemento del carrusel actualizado correctamente"
            );

            await loadCarrusel();

            setTimeout(() => {
                const modalElement = document.getElementById("editCarruselModal");

                if (modalElement && window.bootstrap?.Modal) {
                    const modalInstance =
                        window.bootstrap.Modal.getInstance(modalElement) ||
                        new window.bootstrap.Modal(modalElement);

                    modalInstance.hide();
                }

                resetEditCarruselModal();
            }, 1200);
        } catch (error) {
            console.error("Error al actualizar carrusel:", error);
            setEditCarruselErrorMessage(
                error.message || "Ocurrió un error al actualizar el elemento del carrusel"
            );
        } finally {
            setSavingEditCarrusel(false);
        }
    };

    useEffect(() => {
        const modalElement = document.getElementById("editCarruselModal");

        if (!modalElement) return;

        const handleHiddenModal = () => {
            resetEditCarruselModal();
        };

        modalElement.addEventListener("hidden.bs.modal", handleHiddenModal);

        return () => {
            modalElement.removeEventListener("hidden.bs.modal", handleHiddenModal);
        };
    }, []);

    // Funcion para Desactivar elemento del carrusel

    const handleDeleteCarrusel = async (carruselId, carruselTitulo) => {
        try {
            const result = await Swal.fire({
                title: "¿Seguro que quieres eliminar este elemento?",
                text: `Se desactivará "${carruselTitulo}". Esta función es irreversible.`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            });

            if (!result.isConfirmed) return;

            const response = await fetch(
                `${API_BASE}/api/admin/widgets/carrusel/${carruselId}/status`,
                {
                    method: "PATCH",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No se pudo desactivar el elemento del carrusel"
                );
            }

            await Swal.fire({
                title: "Elemento eliminado",
                text: data?.message || "Elemento del carrusel desactivado correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#3085d6",
            });

            await loadCarrusel();
        } catch (error) {
            console.error("Error al desactivar carrusel:", error);

            await Swal.fire({
                title: "Error",
                text: error.message || "Ocurrió un error al desactivar el carrusel",
                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#d33",
            });
        }
    };

    const openAddCarruselModal = () => {
        resetCarruselMessages();

        setCarruselForm({
            ...initialCarruselForm,
            carrusel_orden: getNextCarruselOrden(),
        });

        setCarruselImagePreview("");

        const fileInput = document.getElementById("carrusel_imagen");
        if (fileInput) fileInput.value = "";
    };

    // Reportes en excel
    const handleDownloadCarruselReport = async () => {
        try {
            setDownloadingReport(true);

            const params = new URLSearchParams();

            if (searchTerm.trim()) params.append("search", searchTerm.trim());
            if (sectionFilter) params.append("section", sectionFilter);
            if (dateFilterMode) params.append("dateMode", dateFilterMode);
            if (monthFilter) params.append("month", monthFilter);
            if (startDateFilter) params.append("startDate", startDateFilter);
            if (endDateFilter) params.append("endDate", endDateFilter);

            const response = await fetch(
                `${API_BASE}/api/admin/widgets/carrusel/report/excel?${params.toString()}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            if (!response.ok) {
                throw new Error("No fue posible descargar el reporte");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "reporte-carrusel.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error descargando reporte:", error);

            await Swal.fire({
                title: "Error",
                text: error.message || "No fue posible descargar el reporte",
                icon: "error",
                confirmButtonText: "Aceptar",
            });
        } finally {
            setDownloadingReport(false);
        }
    };

    // Filtros

    const filteredCarruselList = useMemo(() => {
        return carruselList.filter((item) => {
            const title = String(item.Carrusel_Titulo || "").toLowerCase();
            const description = String(item.Carrusel_Descripcion || "").toLowerCase();
            const search = searchTerm.trim().toLowerCase();

            const matchesSearch =
                !search ||
                title.includes(search) ||
                description.includes(search);

            const matchesSection =
                !sectionFilter || item.Carrusel_Seccion === sectionFilter;

            let matchesDate = true;

            const itemStartDate = item.Carrusel_Fecha_Inicio
                ? new Date(item.Carrusel_Fecha_Inicio)
                : null;

            if (dateFilterMode === "basic" && monthFilter) {
                if (!itemStartDate || Number.isNaN(itemStartDate.getTime())) {
                    matchesDate = false;
                } else {
                    const itemMonth = String(itemStartDate.getMonth() + 1).padStart(2, "0");
                    matchesDate = itemMonth === monthFilter;
                }
            }

            if (dateFilterMode === "advanced") {
                if (startDateFilter) {
                    const start = new Date(`${startDateFilter}T00:00:00`);
                    if (!itemStartDate || itemStartDate < start) {
                        matchesDate = false;
                    }
                }

                if (endDateFilter) {
                    const end = new Date(`${endDateFilter}T23:59:59`);
                    if (!itemStartDate || itemStartDate > end) {
                        matchesDate = false;
                    }
                }
            }

            return matchesSearch && matchesSection && matchesDate;
        });
    }, [
        carruselList,
        searchTerm,
        sectionFilter,
        dateFilterMode,
        monthFilter,
        startDateFilter,
        endDateFilter,
    ]);

    // Paginador 

    const {
        currentPage,
        totalPages,
        totalItems,
        paginatedItems,
        visiblePages,
        startItem,
        endItem,
        goToPage,
        goToPreviousPage,
        goToNextPage,
        resetPagination,
        hasPreviousPage,
        hasNextPage,
    } = usePagination(filteredCarruselList, 8, 5);

    useEffect(() => {
        resetPagination();
    }, [
        searchTerm,
        sectionFilter,
        dateFilterMode,
        monthFilter,
        startDateFilter,
        endDateFilter,
    ]);

    const handleClearCarruselFilters = () => {
        setSearchTerm("");
        setSectionFilter("");
        setDateFilterMode("basic");
        setMonthFilter("");
        setStartDateFilter("");
        setEndDateFilter("");
    };

    

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>

            <div class="content-inner container-fluid pb-0" id="page_layout">
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Carrusel </h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div className="card-header d-flex justify-content-end">
                                <div className="row g-2 align-items-end w-100">
                                    <div className="col-md-3">
                                        <label className="form-label mb-1">Buscar</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Título o descripción..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-md-2">
                                        <label className="form-label mb-1">Sección</label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={sectionFilter}
                                            onChange={(e) => setSectionFilter(e.target.value)}
                                        >
                                            <option value="">Todas</option>
                                            <option value="superior">Superior</option>
                                            <option value="inferior">Inferior</option>
                                        </select>
                                    </div>

                                    <div className="col-md-1">
                                        <label className="form-label mb-1 d-block">Tipo fecha</label>

                                        <div className="form-check form-switch mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="dateFilterSwitch"
                                                checked={dateFilterMode === "advanced"}
                                                onChange={(e) => {
                                                    const isAdvanced = e.target.checked;

                                                    setDateFilterMode(isAdvanced ? "advanced" : "basic");

                                                    setMonthFilter("");
                                                    setStartDateFilter("");
                                                    setEndDateFilter("");
                                                }}
                                            />

                                            <label
                                                className="form-check-label small"
                                                htmlFor="dateFilterSwitch"
                                            >
                                                {dateFilterMode === "advanced"
                                                    ? "Avanzado"
                                                    : "Básico"}
                                            </label>
                                        </div>
                                    </div>

                                    {dateFilterMode === "basic" ? (
                                        <div className="col-md-3">
                                            <label className="form-label mb-1">Mes</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={monthFilter}
                                                onChange={(e) => setMonthFilter(e.target.value)}
                                            >
                                                <option value="">Todos</option>
                                                {monthOptions.map((month) => (
                                                    <option key={month.value} value={month.value}>
                                                        {month.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="col-md-3">
                                                <label className="form-label mb-1">Desde</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={startDateFilter}
                                                    onChange={(e) => setStartDateFilter(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label mb-1">Hasta</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={endDateFilter}
                                                    onChange={(e) => setEndDateFilter(e.target.value)}
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="col-md-3 d-flex justify-content-end gap-2 ms-auto">
                                        <button
                                            type="button"
                                            className="btn btn-secondary-subtle btn-sm"
                                            onClick={handleClearCarruselFilters}
                                            title="Limpiar filtros"
                                        >
                                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.4">
                                            <path
                                                d="M4.88076 14.6713C4.74978 14.2784 4.32504 14.066 3.93208 14.197C3.53912 14.328 3.32675 14.7527 3.45774 15.1457L4.88076 14.6713ZM20.8808 15.1457C21.0117 14.7527 20.7994 14.328 20.4064 14.197C20.0135 14.066 19.5887 14.2784 19.4577 14.6713L20.8808 15.1457ZM4.16925 14.9085C3.45774 15.1457 3.45785 15.146 3.45797 15.1464C3.45802 15.1465 3.45815 15.1469 3.45825 15.1472C3.45845 15.1478 3.45868 15.1485 3.45895 15.1493C3.45948 15.1509 3.46013 15.1528 3.46092 15.1551C3.46249 15.1597 3.46456 15.1657 3.46716 15.1731C3.47235 15.188 3.47961 15.2084 3.48902 15.2341C3.50782 15.2854 3.53521 15.3576 3.5717 15.4477C3.64461 15.6279 3.7542 15.8805 3.90468 16.1814C4.2048 16.7817 4.67223 17.5836 5.34308 18.3886C6.68942 20.0043 8.88343 21.6585 12.1693 21.6585V20.1585C9.45507 20.1585 7.64908 18.8128 6.49542 17.4284C5.91627 16.7334 5.5087 16.0354 5.24632 15.5106C5.11555 15.2491 5.02201 15.0329 4.96212 14.8849C4.9322 14.811 4.91076 14.7543 4.89733 14.7177C4.89062 14.6994 4.88593 14.6861 4.88318 14.6783C4.88181 14.6744 4.88093 14.6718 4.88053 14.6706C4.88033 14.67 4.88025 14.6698 4.88029 14.6699C4.88031 14.67 4.88036 14.6701 4.88044 14.6704C4.88047 14.6705 4.88056 14.6707 4.88058 14.6708C4.88067 14.671 4.88076 14.6713 4.16925 14.9085ZM12.1693 21.6585C15.4551 21.6585 17.6491 20.0043 18.9954 18.3886C19.6663 17.5836 20.1337 16.7817 20.4338 16.1814C20.5843 15.8805 20.6939 15.6279 20.7668 15.4477C20.8033 15.3576 20.8307 15.2854 20.8495 15.2341C20.8589 15.2084 20.8662 15.188 20.8713 15.1731C20.8739 15.1657 20.876 15.1597 20.8776 15.1551C20.8784 15.1528 20.879 15.1509 20.8796 15.1493C20.8798 15.1485 20.8801 15.1478 20.8803 15.1472C20.8804 15.1469 20.8805 15.1465 20.8805 15.1464C20.8807 15.146 20.8808 15.1457 20.1693 14.9085C19.4577 14.6713 19.4578 14.671 19.4579 14.6708C19.4579 14.6707 19.458 14.6705 19.4581 14.6704C19.4581 14.6701 19.4582 14.67 19.4582 14.6699C19.4583 14.6698 19.4582 14.67 19.458 14.6706C19.4576 14.6718 19.4567 14.6744 19.4553 14.6783C19.4526 14.6861 19.4479 14.6994 19.4412 14.7177C19.4277 14.7543 19.4063 14.811 19.3764 14.8849C19.3165 15.0329 19.223 15.2491 19.0922 15.5106C18.8298 16.0354 18.4222 16.7334 17.8431 17.4284C16.6894 18.8128 14.8834 20.1585 12.1693 20.1585V21.6585Z"
                                                fill="currentColor"></path>
                                            <path d="M21.5183 19.2271C21.4293 19.2234 21.3427 19.196 21.2671 19.1465L16.3546 15.8924C16.2197 15.8026 16.1413 15.6537 16.148 15.4969C16.1546 15.34 16.2452 15.1982 16.3873 15.1202L21.5571 12.2926C21.7075 12.2106 21.8932 12.213 22.0416 12.3003C22.1907 12.387 22.2783 12.5436 22.2712 12.7096L22.014 18.7913C22.007 18.9573 21.9065 19.1059 21.7506 19.1797C21.6772 19.215 21.597 19.2305 21.5183 19.2271" fill="currentColor"></path>
                                            </g>
                                            <path
                                            d="M20.0742 10.0265C20.1886 10.4246 20.6041 10.6546 21.0022 10.5401C21.4003 10.4257 21.6302 10.0102 21.5158 9.61214L20.0742 10.0265ZM4.10803 8.88317C3.96071 9.27031 4.15513 9.70356 4.54226 9.85087C4.92939 9.99818 5.36265 9.80377 5.50996 9.41664L4.10803 8.88317ZM20.795 9.81934C21.5158 9.61214 21.5157 9.6118 21.5156 9.61144C21.5155 9.61129 21.5154 9.6109 21.5153 9.61059C21.5152 9.60998 21.515 9.60928 21.5147 9.60848C21.5143 9.60689 21.5137 9.60493 21.513 9.6026C21.5116 9.59795 21.5098 9.59184 21.5075 9.58431C21.503 9.56925 21.4966 9.54853 21.4882 9.52251C21.4716 9.47048 21.4473 9.39719 21.4146 9.3056C21.3493 9.12256 21.2503 8.8656 21.1126 8.55861C20.8378 7.94634 20.4044 7.12552 19.7678 6.29313C18.4902 4.62261 16.3673 2.87801 13.0844 2.74053L13.0216 4.23922C15.7334 4.35278 17.4816 5.77291 18.5763 7.20436C19.1258 7.92295 19.5038 8.63743 19.744 9.17271C19.8638 9.43949 19.9482 9.65937 20.0018 9.80972C20.0286 9.88483 20.0477 9.94238 20.0596 9.97951C20.0655 9.99808 20.0696 10.0115 20.072 10.0195C20.0732 10.0235 20.074 10.0261 20.0744 10.0273C20.0746 10.0278 20.0746 10.0281 20.0746 10.028C20.0746 10.0279 20.0745 10.0278 20.0745 10.0275C20.0744 10.0274 20.0744 10.0272 20.0743 10.0271C20.0743 10.0268 20.0742 10.0265 20.795 9.81934ZM13.0844 2.74053C9.80146 2.60306 7.54016 4.16407 6.12741 5.72193C5.42345 6.49818 4.92288 7.27989 4.59791 7.86704C4.43497 8.16144 4.31491 8.40923 4.23452 8.58617C4.1943 8.67471 4.16391 8.7457 4.14298 8.79616C4.13251 8.82139 4.1244 8.84151 4.11859 8.85613C4.11568 8.86344 4.11336 8.86938 4.1116 8.8739C4.11072 8.87616 4.10998 8.87807 4.10939 8.87962C4.10909 8.88039 4.10883 8.88108 4.1086 8.88167C4.10849 8.88196 4.10834 8.88234 4.10829 8.88249C4.10815 8.88284 4.10803 8.88317 4.80899 9.14991C5.50996 9.41664 5.50985 9.41692 5.50975 9.41719C5.50973 9.41725 5.50964 9.41749 5.50959 9.4176C5.5095 9.41784 5.50945 9.41798 5.50942 9.41804C5.50938 9.41816 5.50947 9.41792 5.50969 9.41734C5.51014 9.41619 5.51113 9.41365 5.51267 9.40979C5.51574 9.40206 5.52099 9.38901 5.52846 9.37101C5.5434 9.335 5.56719 9.27924 5.60018 9.20664C5.66621 9.0613 5.76871 8.84925 5.91031 8.59341C6.19442 8.08008 6.63084 7.39971 7.23855 6.72958C8.44912 5.39466 10.3098 4.12566 13.0216 4.23922L13.0844 2.74053Z"
                                            fill="currentColor"></path>
                                            <path d="M8.78337 9.33604C8.72981 9.40713 8.65805 9.46292 8.57443 9.49703L3.1072 11.6951C2.95672 11.7552 2.78966 11.7352 2.66427 11.6407C2.53887 11.5462 2.47359 11.3912 2.48993 11.2299L3.09576 5.36863C3.11367 5.19823 3.22102 5.04666 3.37711 4.97402C3.5331 4.9005 3.71173 4.91728 3.84442 5.01726L8.70581 8.68052C8.8385 8.78051 8.90387 8.94759 8.8762 9.1178C8.86358 9.19825 8.83082 9.27308 8.78337 9.33604" fill="currentColor"></path>
                                        </svg> 
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={handleDownloadCarruselReport}
                                            disabled={downloadingReport}
                                        >
                                            <svg  width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">                                <path opacity="0.4" d="M16.6756 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0711 3.92889 22 7.33333 22H16.6756C20.08 22 22 20.0711 22 16.6667V7.33333C22 3.92889 20.08 2 16.6756 2Z" fill="currentColor"></path>                                <path d="M7.36866 9.3689C6.91533 9.3689 6.54199 9.74223 6.54199 10.2045V17.0756C6.54199 17.5289 6.91533 17.9022 7.36866 17.9022C7.83088 17.9022 8.20421 17.5289 8.20421 17.0756V10.2045C8.20421 9.74223 7.83088 9.3689 7.36866 9.3689Z" fill="currentColor"></path>                                <path d="M12.0352 6.08887C11.5818 6.08887 11.2085 6.4622 11.2085 6.92442V17.0755C11.2085 17.5289 11.5818 1 7.9022 12.0352 17.9022C12.4974 17.9022 12.8707 17.5289 12.8707 17.0755V6.92442C12.8707 6.4622 12.4974 6.08887 12.0352 6.08887Z" fill="currentColor"></path>                                <path d="M16.6398 12.9956C16.1775 12.9956 15.8042 13.3689 15.8042 13.8312V17.0756C15.8042 17.5289 16.1775 17.9023 16.6309 17.9023C17.0931 17.9023 17.4664 17.5289 17.4664 17.0756V13.8312C17.4664 13.3689 17.0931 12.9956 16.6398 12.9956Z" fill="currentColor"></path>                                </svg>                            
                                            {downloadingReport ? <> <span class="spinner-border spinner-border-sm" style={{marginLeft:'5px'}} role="status" aria-hidden="true"></span></> : "Excel"}
                                        </button>

                                        <button
                                            className="btn btn-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#addCarruselModal"
                                            onClick={openAddCarruselModal}
                                        >
                                            <span className="btn-inner mr-5">
                                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" className="icon-24">
                                                    <path
                                                        d="M12 4V20M20 12H4"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            Agregar Carrusel
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="card-body px-0">
                                <div class="table-responsive">
                                    <table id="user-list-table" class="table table-striped" role="grid" data-toggle="data-table">
                                        <thead>
                                            <tr class="ligth">
                                            <th># Orden</th>
                                            <th>Titulo</th>
                                            <th>Sección</th>
                                            <th>Fecha inicio</th>
                                            <th>Fecha Fin</th>
                                            <th>Estado</th>
                                            <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loadingCarrusel ? (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                                                            <div className="col-md-12 col-sm-4 mb-4">
                                                                <div className="iq-loader-box">
                                                                    <div className="iq-loader-1"></div>
                                                                </div>
                                                            </div>

                                                            <span className="text-muted">
                                                                Cargando elementos del carrusel...
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : carruselListError ? (
                                                <tr>
                                                    <td colSpan="5" className="text-center text-danger">
                                                        {carruselListError}
                                                    </td>
                                                </tr>
                                            ) : paginatedItems.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No hay elementos registrados en el carrusel
                                                    </td>
                                                </tr>
                                            ) : (
                                                paginatedItems.map((item) => (
                                                    <tr key={item.Carrusel_ID}>
                                                        <td className="text-center">{item.Carrusel_Orden}</td>
                                                        <td>
                                                            {item.Carrusel_Titulo?.trim()
                                                                ? item.Carrusel_Titulo
                                                                : item.Carrusel_Descripcion?.trim()
                                                                    ? `${item.Carrusel_Descripcion.trim().slice(0, 30)}...`
                                                                    : "Sin título"}
                                                        </td>
                                                        <td style={{ textTransform: "capitalize" }}>
                                                            {item.Carrusel_Seccion}
                                                        </td>
                                                        <td>{formatCarruselDate(item.Carrusel_Fecha_Inicio)}</td>

                                                        <td>{formatCarruselDate(item.Carrusel_Fecha_Fin)}</td>

                                                        <td>
                                                            {(() => {
                                                                const status = getCarruselStatus(item);

                                                                if (status === "scheduled") {
                                                                    return (
                                                                        <span className="badge bg-warning-subtle text-warning p-2">
                                                                            Programado
                                                                        </span>
                                                                    );
                                                                }

                                                                if (status === "active") {
                                                                    return (
                                                                        <span className="badge bg-success-subtle text-success p-2">
                                                                            Activo
                                                                        </span>
                                                                    );
                                                                }

                                                                if (status === "finished") {
                                                                    return (
                                                                        <span className="badge bg-secondary-subtle text-secondary p-2">
                                                                            Finalizado
                                                                        </span>
                                                                    );
                                                                }

                                                                return (
                                                                    <span className="badge bg-danger-subtle text-danger p-2">
                                                                        Inactivo
                                                                    </span>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-info-subtle ms-2"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#viewCarruselModal"
                                                                    onClick={() => handleViewCarrusel(item.Carrusel_ID)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                                d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-warning-subtle ms-2"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#editCarruselModal"
                                                                    onClick={() => handleLoadEditCarrusel(item.Carrusel_ID)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-danger-subtle ms-2"
                                                                    onClick={() => handleDeleteCarrusel(item.Carrusel_ID, item.Carrusel_Titulo)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <UniversalPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                startItem={startItem}
                                endItem={endItem}
                                visiblePages={visiblePages}
                                onPageChange={goToPage}
                                onPrevious={goToPreviousPage}
                                onNext={goToNextPage}
                                hasPreviousPage={hasPreviousPage}
                                hasNextPage={hasNextPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </main>

        {/* Modal para agregar Elemento al carrusel */}
        <div
            className="modal fade"
            id="addCarruselModal"
            tabIndex="-1"
            aria-labelledby="addCarruselModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content">
                    <form onSubmit={handleAddCarrusel}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="addCarruselModalLabel">
                                Agregar Carrusel
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                disabled={addingCarrusel}
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Sección: <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        name="carrusel_seccion"
                                        className="form-select"
                                        value={carruselForm.carrusel_seccion}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                    >
                                        <option value="superior">Superior</option>
                                        <option value="inferior">Inferior</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Orden: <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        name="carrusel_orden"
                                        className="form-control"
                                        value={carruselForm.carrusel_orden}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-8">
                                    <label className="form-label">
                                        Título: <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="carrusel_titulo"
                                        className="form-control"
                                        value={carruselForm.carrusel_titulo}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Activo
                                    </label>
                                    <select
                                        name="carrusel_activo"
                                        className="form-select"
                                        value={carruselForm.carrusel_activo}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                    >
                                        <option value={1}>Sí</option>
                                        <option value={0}>No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label className="form-label">
                                        Imagen: <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="file"
                                        name="carrusel_imagen"
                                        className="form-control"
                                        accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml,.svg"
                                        onChange={handleCarruselImageChange}
                                        disabled={addingCarrusel}
                                    />
                                </div>

                                {carruselImagePreview ? (
                                    <div className="col-md-12 mt-3">
                                        <img
                                            src={carruselImagePreview}
                                            alt="Vista previa carrusel"
                                            style={{
                                                maxWidth: "220px",
                                                borderRadius: "10px",
                                                border: "1px solid #ddd",
                                            }}
                                        />
                                    </div>
                                ) : null}
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label className="form-label">Descripción</label>
                                    <textarea
                                        name="carrusel_descripcion"
                                        className="form-control"
                                        rows="3"
                                        value={carruselForm.carrusel_descripcion}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                        placeholder="Escribe la descripción..."
                                    />
                                    {/* <div className="border rounded video-quill-wrapper">
                                        <ReactQuill
                                            theme="snow"
                                            placeholder="Escribe la descripción del carrusel..."
                                            value={carruselForm.carrusel_descripcion}
                                            onChange={handleCarruselDescriptionChange}
                                            readOnly={addingCarrusel}
                                        />
                                    </div> */}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label className="form-label">URL del elemento</label>
                                    <input
                                        type="text"
                                        name="carrusel_url"
                                        className="form-control"
                                        value={carruselForm.carrusel_url}
                                        onChange={handleCarruselInputChange}
                                        disabled={addingCarrusel}
                                        placeholder="https://... o /ruta-interna"
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Fecha de inicio</label>
                                    <input
                                        type="datetime-local"
                                        name="carrusel_fecha_inicio"
                                        className="form-control"
                                        value={carruselForm.carrusel_fecha_inicio}
                                        onChange={handleCarruselInputChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Fecha de finalización</label>
                                    <input
                                        type="datetime-local"
                                        name="carrusel_fecha_fin"
                                        className="form-control"
                                        value={carruselForm.carrusel_fecha_fin}
                                        onChange={handleCarruselInputChange}
                                    />
                                </div>
                            </div>

                            {carruselSuccessMessage ? (
                                <div
                                    className="mb-3 alert alert-left alert-success alert-dismissible fade show"
                                    role="alert"
                                >
                                    <span>{carruselSuccessMessage}</span>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setCarruselSuccessMessage("")}
                                    ></button>
                                </div>
                            ) : null}

                            {carruselInfoMessage ? (
                                <div
                                    className="mb-3 alert alert-top alert-info alert-dismissible fade show"
                                    role="alert"
                                >
                                    <span>{carruselInfoMessage}</span>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setCarruselInfoMessage("")}
                                    ></button>
                                </div>
                            ) : null}

                            {carruselErrorMessage ? (
                                <div
                                    className="alert alert-bottom alert-danger alert-dismissible fade show"
                                    role="alert"
                                >
                                    <span>{carruselErrorMessage}</span>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setCarruselErrorMessage("")}
                                    ></button>
                                </div>
                            ) : null}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                disabled={addingCarrusel}
                            >
                                Cerrar
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={addingCarrusel}
                            >
                                {addingCarrusel ? "Agregando..." : "Agregar"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        {/* Modal para ver Elemento al carrusel */}
        <div
            className="modal fade"
            id="viewCarruselModal"
            tabIndex="-1"
            aria-labelledby="viewCarruselModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="viewCarruselModalLabel">
                            Detalle del Carrusel
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={resetViewCarruselModal}
                        ></button>
                    </div>

                    <div className="modal-body">
                        {loadingViewCarrusel ? (
                            <div className="text-center py-4">
                                Cargando detalle del carrusel...
                            </div>
                        ) : viewCarruselError ? (
                            <div className="alert alert-danger" role="alert">
                                {viewCarruselError}
                            </div>
                        ) : !viewCarruselData ? (
                            <div className="alert alert-info" role="alert">
                                No hay información disponible del carrusel.
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-md-12 mb-4 text-center">
                                    {viewCarruselData.Carrusel_Imagen_URL ? (
                                        <img
                                            src={viewCarruselData.Carrusel_Imagen_URL}
                                            alt={viewCarruselData.Carrusel_Titulo || "Carrusel"}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "260px",
                                                borderRadius: "12px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <div className="form-control ">
                                            Sin imagen
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Título</label>
                                    <div className="form-control ">
                                        {viewCarruselData.Carrusel_Titulo || "-"}
                                    </div>
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label className="form-label fw-bold">Sección</label>
                                    <div
                                        className="form-control "
                                        style={{ textTransform: "capitalize" }}
                                    >
                                        {viewCarruselData.Carrusel_Seccion || "-"}
                                    </div>
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label className="form-label fw-bold">Total clicks</label>
                                    <div className="form-control ">
                                        {viewCarruselData.Carrusel_Total_Clicks ?? 0}
                                    </div>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">URL</label>
                                    <div className="form-control ">
                                        {viewCarruselData.Carrusel_URL || "-"}
                                    </div>
                                </div>

                                

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Creado por</label>
                                    <div className="form-control ">
                                        {`${viewCarruselData.Creador_Nombre || ""} ${viewCarruselData.Creador_Apellido || ""}`.trim() || "-"}
                                    </div>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Actualizado por</label>
                                    <div className="form-control ">
                                        {`${viewCarruselData.Actualizador_Nombre || ""} ${viewCarruselData.Actualizador_Apellido || ""}`.trim() || "-"}
                                    </div>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Fecha de creación / actualización</label>
                                    <div className="form-control ">
                                        {formatCarruselDateTime(viewCarruselData.Carrusel_Act)}
                                    </div>
                                </div>

                                <div className="col-md-12 mb-3">
                                    <label className="form-label fw-bold">Descripción</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={viewCarruselData.Carrusel_Descripcion || ""}
                                        readOnly
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={resetViewCarruselModal}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        {/* Modal para editar Elemento al carrusel */}
        <div
            className="modal fade"
            id="editCarruselModal"
            tabIndex="-1"
            aria-labelledby="editCarruselModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content">
                    <form onSubmit={handleUpdateCarrusel}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="editCarruselModalLabel">
                                Editar Carrusel
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                disabled={savingEditCarrusel}
                                onClick={resetEditCarruselModal}
                            ></button>
                        </div>

                        <div className="modal-body">
                            {loadingEditCarrusel ? (
                                <div className="text-center py-4">
                                    Cargando información del carrusel...
                                </div>
                            ) : (
                                <>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">
                                                Sección: <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                name="carrusel_seccion"
                                                className="form-select"
                                                value={editCarruselForm.carrusel_seccion}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            >
                                                <option value="superior">Superior</option>
                                                <option value="inferior">Inferior</option>
                                            </select>
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">
                                                Orden: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="1"
                                                name="carrusel_orden"
                                                className="form-control"
                                                value={editCarruselForm.carrusel_orden}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-8">
                                            <label className="form-label">
                                                Título: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="carrusel_titulo"
                                                className="form-control"
                                                value={editCarruselForm.carrusel_titulo}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Activo</label>
                                            <select
                                                name="carrusel_activo"
                                                className="form-select"
                                                value={editCarruselForm.carrusel_activo}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            >
                                                <option value={1}>Sí</option>
                                                <option value={0}>No</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label className="form-label">Imagen</label>
                                            <input
                                                type="file"
                                                name="carrusel_imagen"
                                                className="form-control"
                                                accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml,.svg"
                                                onChange={handleEditCarruselImageChange}
                                                disabled={savingEditCarrusel}
                                            />
                                        </div>

                                        {editCarruselImagePreview ? (
                                            <div className="col-md-12 mt-3">
                                                <img
                                                    src={editCarruselImagePreview}
                                                    alt="Vista previa carrusel"
                                                    style={{
                                                        maxWidth: "220px",
                                                        borderRadius: "10px",
                                                        border: "1px solid #ddd",
                                                    }}
                                                />
                                            </div>
                                        ) : null}
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label className="form-label">Descripción</label>
                                            <textarea
                                                name="carrusel_descripcion"
                                                className="form-control"
                                                rows="4"
                                                value={editCarruselForm.carrusel_descripcion}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                                placeholder="Escribe la descripción..."
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <label className="form-label">URL del elemento</label>
                                            <input
                                                type="text"
                                                name="carrusel_url"
                                                className="form-control"
                                                value={editCarruselForm.carrusel_url}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                                placeholder="https://... o /ruta-interna"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Fecha de inicio</label>
                                            <input
                                                type="datetime-local"
                                                name="carrusel_fecha_inicio"
                                                className="form-control"
                                                value={editCarruselForm.carrusel_fecha_inicio}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Fecha de finalización</label>
                                            <input
                                                type="datetime-local"
                                                name="carrusel_fecha_fin"
                                                className="form-control"
                                                value={editCarruselForm.carrusel_fecha_fin}
                                                onChange={handleEditCarruselInputChange}
                                                disabled={savingEditCarrusel}
                                            />
                                        </div>
                                    </div>

                                    {editCarruselSuccessMessage ? (
                                        <div
                                            className="mb-3 alert alert-left alert-success alert-dismissible fade show"
                                            role="alert"
                                        >
                                            <span>{editCarruselSuccessMessage}</span>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                aria-label="Close"
                                                onClick={() => setEditCarruselSuccessMessage("")}
                                            ></button>
                                        </div>
                                    ) : null}

                                    {editCarruselInfoMessage ? (
                                        <div
                                            className="mb-3 alert alert-top alert-info alert-dismissible fade show"
                                            role="alert"
                                        >
                                            <span>{editCarruselInfoMessage}</span>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                aria-label="Close"
                                                onClick={() => setEditCarruselInfoMessage("")}
                                            ></button>
                                        </div>
                                    ) : null}

                                    {editCarruselErrorMessage ? (
                                        <div
                                            className="alert alert-bottom alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            <span>{editCarruselErrorMessage}</span>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                aria-label="Close"
                                                onClick={() => setEditCarruselErrorMessage("")}
                                            ></button>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                disabled={savingEditCarrusel}
                                onClick={resetEditCarruselModal}
                            >
                                Cerrar
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={savingEditCarrusel || loadingEditCarrusel}
                            >
                                {savingEditCarrusel ? "Guardando..." : "Guardar cambios"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>


        </>
    )
}

export default CarruselList